import ReportCardPreview from './ReportCardPreview';

export default ReportCardPreview;
